export * from "./practitioner-type";
